import { render, staticRenderFns } from "./precious.vue?vue&type=template&id=24037b26&scoped=true"
import script from "./precious.vue?vue&type=script&lang=js"
export * from "./precious.vue?vue&type=script&lang=js"
import style0 from "./precious.vue?vue&type=style&index=0&id=24037b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24037b26",
  null
  
)

export default component.exports